import { FC } from "react";
import s from "./app-icons.module.scss";

interface IIconProps {
  width?: number;
  height?: number;
  sharedStyles?: string;
}

export const UserIcon: FC<IIconProps> = ({
  width = 20,
  height = 20,
  sharedStyles,
}) => {
  return (
    <svg
      className={sharedStyles}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.444 11.8074C11.0814 11.2982 11.5386 10.6152 11.7535 9.85097C11.9683 9.08674 11.9305 8.27826 11.6451 7.53514C11.3596 6.79202 10.8405 6.15021 10.1579 5.69672C9.47536 5.24323 8.66245 5 7.82939 5C6.99634 5 6.18343 5.24323 5.50088 5.69672C4.81832 6.15021 4.29915 6.79202 4.01373 7.53514C3.72832 8.27826 3.69047 9.08674 3.90533 9.85097C4.12018 10.6152 4.57734 11.2982 5.21482 11.8074C4.18095 12.2517 3.29128 12.9507 2.63833 13.832C2.52244 13.9887 2.47673 14.1826 2.51123 14.3713C2.54573 14.5599 2.65762 14.7279 2.82236 14.8383C2.95008 14.925 3.10325 14.9713 3.26024 14.9709C3.38234 14.9712 3.50271 14.9434 3.61103 14.8899C3.71935 14.8364 3.81238 14.7587 3.88215 14.6635C4.32709 14.0618 4.91806 13.5707 5.60511 13.2316C6.29215 12.8926 7.05508 12.7155 7.82939 12.7155C8.6037 12.7155 9.36663 12.8926 10.0537 13.2316C10.7407 13.5707 11.3317 14.0618 11.7766 14.6635C11.8318 14.7463 11.9041 14.8176 11.9891 14.873C12.0742 14.9285 12.1702 14.9669 12.2714 14.9861C12.3726 15.0052 12.4768 15.0046 12.5777 14.9844C12.6787 14.9641 12.7742 14.9245 12.8586 14.8682C12.9429 14.8118 13.0143 14.7397 13.0685 14.6563C13.1226 14.5729 13.1583 14.4799 13.1734 14.383C13.1886 14.2861 13.1828 14.1873 13.1565 14.0926C13.1302 13.9979 13.0839 13.9092 13.0205 13.832C12.3675 12.9507 11.4778 12.2517 10.444 11.8074ZM5.29097 8.8609C5.29097 8.3842 5.43985 7.91821 5.71878 7.52185C5.9977 7.12549 6.39415 6.81656 6.85798 6.63413C7.32182 6.45171 7.83221 6.40398 8.32461 6.49698C8.81702 6.58998 9.26932 6.81953 9.62433 7.15661C9.97933 7.49369 10.2211 7.92315 10.319 8.39069C10.417 8.85823 10.3667 9.34285 10.1746 9.78326C9.98246 10.2237 9.6571 10.6001 9.23966 10.8649C8.82222 11.1298 8.33144 11.2711 7.82939 11.2711C7.15616 11.2711 6.51051 11.0172 6.03446 10.5652C5.55841 10.1132 5.29097 9.50014 5.29097 8.8609ZM18.0085 14.8383C17.8807 14.925 17.7276 14.9713 17.5706 14.9709C17.4487 14.9702 17.3287 14.942 17.2205 14.8885C17.1124 14.8351 17.0192 14.758 16.9487 14.6635C16.5028 14.0629 15.9116 13.5726 15.2247 13.2339C14.5378 12.8953 13.7754 12.7181 13.0014 12.7173C12.7995 12.7173 12.6058 12.6411 12.4629 12.5055C12.3201 12.3699 12.2399 12.186 12.2399 11.9942C12.2399 11.8024 12.3201 11.6185 12.4629 11.4829C12.6058 11.3473 12.7995 11.2711 13.0014 11.2711C13.6747 11.2711 14.3203 11.0172 14.7964 10.5652C15.2724 10.1132 15.5398 9.50014 15.5398 8.8609C15.5398 8.22167 15.2724 7.60862 14.7964 7.15661C14.3203 6.7046 13.6747 6.45067 13.0014 6.45067C12.7696 6.45025 12.5389 6.48068 12.316 6.54105C12.2193 6.56846 12.1177 6.57732 12.0173 6.56711C11.9168 6.55689 11.8195 6.52781 11.7311 6.48155C11.6426 6.43529 11.5647 6.37279 11.5019 6.29767C11.4391 6.22255 11.3927 6.13632 11.3653 6.044C11.338 5.95169 11.3302 5.85512 11.3425 5.75993C11.3549 5.66475 11.387 5.57284 11.4371 5.48956C11.4872 5.40628 11.5542 5.33329 11.6343 5.27485C11.7144 5.21641 11.8059 5.17367 11.9036 5.14914C12.2606 5.05261 12.6302 5.00394 13.0014 5.00452C13.835 5.00223 14.6491 5.24392 15.3329 5.69671C16.0166 6.14949 16.5368 6.79136 16.8226 7.53491C17.1084 8.27847 17.1459 9.08759 16.9299 9.85211C16.714 10.6166 16.2552 11.2994 15.616 11.8074C16.6499 12.2517 17.5395 12.9507 18.1925 13.832C18.2507 13.9093 18.2921 13.9968 18.3144 14.0895C18.3367 14.1821 18.3393 14.2781 18.3222 14.3717C18.3051 14.4653 18.2685 14.5548 18.2147 14.6349C18.1608 14.715 18.0907 14.7841 18.0085 14.8383Z"
        fill="#8C94A5"
      />
    </svg>
  );
};

export const RolesIcon: FC<IIconProps> = ({
  width = 20,
  height = 20,
  sharedStyles,
}) => {
  return (
    <svg
      className={sharedStyles}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.92 10.5005C13.2568 10.1501 13.6697 9.86968 14.1315 9.67768C14.5934 9.48567 15.0938 9.38641 15.6 9.38641C16.1062 9.38641 16.6066 9.48567 17.0685 9.67768C17.5303 9.86968 17.9432 10.1501 18.28 10.5005C18.4913 10.7198 18.6005 11.0077 18.5837 11.3014C18.5668 11.595 18.4253 11.8706 18.19 12.0678C18.0727 12.1662 17.9356 12.2422 17.7865 12.2913C17.6374 12.3405 17.4793 12.3618 17.3213 12.354C17.1633 12.3463 17.0085 12.3096 16.8658 12.2461C16.7232 12.1827 16.5954 12.0937 16.49 11.9843C16.3783 11.8677 16.2413 11.7743 16.0879 11.7103C15.9345 11.6464 15.7682 11.6133 15.6 11.6133C15.4318 11.6133 15.2655 11.6464 15.1121 11.7103C14.9587 11.7743 14.8217 11.8677 14.71 11.9843C14.6049 12.0933 14.4778 12.1821 14.3357 12.2455C14.1937 12.3089 14.0396 12.3457 13.8822 12.3539C13.7248 12.3621 13.5672 12.3414 13.4184 12.2931C13.2696 12.2448 13.1325 12.1698 13.015 12.0724C12.8975 11.975 12.8018 11.857 12.7334 11.7253C12.665 11.5936 12.6253 11.4507 12.6165 11.3047C12.5986 11.0099 12.7078 10.7206 12.92 10.5005ZM9.29 11.9843C9.50217 12.2044 9.79995 12.3374 10.1178 12.3539C10.4357 12.3704 10.7476 12.2692 10.985 12.0724C11.2224 11.8756 11.3657 11.5995 11.3835 11.3047C11.4014 11.0099 11.2922 10.7206 11.08 10.5005C10.7432 10.1501 10.3303 9.86968 9.86847 9.67768C9.40659 9.48567 8.90616 9.38641 8.4 9.38641C7.89384 9.38641 7.39341 9.48567 6.93153 9.67768C6.46965 9.86968 6.05678 10.1501 5.72 10.5005C5.50783 10.7206 5.39864 11.0099 5.41645 11.3047C5.43427 11.5995 5.57763 11.8756 5.815 12.0724C6.05237 12.2692 6.3643 12.3704 6.68218 12.3539C7.00005 12.3374 7.29783 12.2044 7.51 11.9843C7.62165 11.8677 7.7587 11.7743 7.91211 11.7103C8.06552 11.6464 8.2318 11.6133 8.4 11.6133C8.5682 11.6133 8.73448 11.6464 8.88789 11.7103C9.0413 11.7743 9.17835 11.8677 9.29 11.9843ZM13.99 14.7664C13.4001 15.1293 12.7079 15.3229 12 15.3229C11.2921 15.3229 10.5999 15.1293 10.01 14.7664C9.74478 14.6029 9.42037 14.5437 9.10812 14.602C8.79587 14.6603 8.52137 14.8312 8.345 15.0771C8.16863 15.3231 8.10484 15.6239 8.16767 15.9135C8.23049 16.2031 8.41478 16.4576 8.68 16.6212C9.66437 17.2262 10.8191 17.5488 12 17.5488C13.1809 17.5488 14.3356 17.2262 15.32 16.6212C15.5852 16.4576 15.7695 16.2031 15.8323 15.9135C15.8952 15.6239 15.8314 15.3231 15.655 15.0771C15.4786 14.8312 15.2041 14.6603 14.8919 14.602C14.5796 14.5437 14.2552 14.6029 13.99 14.7664ZM22 3.8512V9.0167C22 12.4109 21.01 15.6196 19.21 18.0401C17.41 20.4606 14.76 22 12 22C9.24 22 6.68 20.5904 4.79 18.0401C2.9 15.4898 2 12.4109 2 9.0167V3.8512C2.00172 3.55008 2.0817 3.25378 2.23314 2.98741C2.38459 2.72104 2.60305 2.49246 2.87 2.32103C3.13822 2.15188 3.44678 2.04576 3.76907 2.01184C4.09137 1.97791 4.41772 2.01718 4.72 2.12628C6.1 2.61779 8.88 3.45243 12 3.45243C15.12 3.45243 17.9 2.61779 19.28 2.12628C19.5823 2.01718 19.9086 1.97791 20.2309 2.01184C20.5532 2.04576 20.8618 2.15188 21.13 2.32103C21.397 2.49246 21.6154 2.72104 21.7669 2.98741C21.9183 3.25378 21.9983 3.55008 22 3.8512ZM19.6 4.38908C17.94 4.93624 15.13 5.67814 12 5.67814C8.87 5.67814 6.06 4.93624 4.4 4.38908V9.0167C4.4 11.9658 5.24 14.7201 6.77 16.7789C8.3 18.8376 10.06 19.7743 12 19.7743C13.94 19.7743 15.8 18.7078 17.23 16.7789C18.66 14.8499 19.6 11.9658 19.6 9.0167V4.38908Z"
        fill="#8C94A5"
      />
    </svg>
  );
};

export const SupportIcon: FC<IIconProps> = ({
  width = 24,
  height = 24,
  sharedStyles,
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={sharedStyles}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 3C7.02947 3 3 7.02947 3 12C3 16.9705 7.02947 21 12 21C16.9705 21 21 16.9705 21 12C21 7.02947 16.9705 3 12 3ZM14.25 4.45856C16.7852 5.21428 18.779 7.21481 19.5358 9.74998H15.8872C15.4924 9.07206 14.9283 8.50838 14.25 8.11423V4.45856ZM15.3685 12.0037C15.3685 13.8658 13.8605 15.3753 12 15.3753C10.1395 15.3753 8.63149 13.8658 8.63149 12.0037C8.63149 10.1415 10.1398 8.63177 12 8.63177C13.8602 8.63177 15.3685 10.1415 15.3685 12.0037ZM10.875 4.21163C11.2426 4.15903 11.6178 4.13034 12 4.13034C12.3819 4.13034 12.7574 4.15903 13.125 4.21163V7.65356C12.765 7.56047 12.3893 7.50591 12 7.50591C11.6108 7.50591 11.2353 7.56047 10.875 7.65356V4.21163ZM9.75002 4.45856V8.11425C9.07221 8.50772 8.50689 9.07303 8.11286 9.75H4.46421C5.22077 7.21481 7.21483 5.2143 9.75002 4.45856ZM4.13036 12.0028C4.13036 11.6192 4.16297 11.244 4.21614 10.875H7.65077C7.55739 11.2355 7.50592 11.6129 7.50592 12.0031C7.50592 12.3909 7.55711 12.7664 7.64936 13.125H4.2153C4.163 12.758 4.13036 12.3842 4.13036 12.0028ZM9.75 19.5467C7.21284 18.7907 5.21824 16.7874 4.46252 14.25H8.10949C8.5038 14.9295 9.07022 15.497 9.75 15.8916V19.5468V19.5467ZM13.125 19.7937C12.7574 19.8463 12.3819 19.8749 12 19.8749C11.6178 19.8749 11.2426 19.846 10.875 19.7937V16.3523C11.2353 16.4454 11.6108 16.4999 12 16.4999C12.3893 16.4999 12.765 16.4454 13.125 16.3523V19.7937ZM14.25 19.5467V15.8916C14.9295 15.497 15.4963 14.9295 15.8903 14.25H19.5373C18.7815 16.7871 16.7869 18.7907 14.25 19.5467L14.25 19.5467ZM16.3507 13.125C16.4429 12.7664 16.4941 12.3909 16.4941 12.003C16.4941 11.6129 16.4426 11.2355 16.349 10.8749H19.7839C19.8368 11.2439 19.8697 11.6191 19.8697 12.0028C19.8697 12.3842 19.8373 12.7582 19.7847 13.125H16.3507Z"
        fill="#8C94A5"
      />
    </svg>
  );
};

export const ColorPickerIcon: FC<IIconProps> = ({
  width = 24,
  height = 24,
  sharedStyles,
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={sharedStyles}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2249 4.77506C19.4707 5.02074 19.6656 5.31241 19.7986 5.63343C19.9316 5.95445 20 6.29851 20 6.64599C20 6.99346 19.9316 7.33753 19.7986 7.65854C19.6656 7.97956 19.4707 8.27124 19.2249 8.51691L17.873 9.86885C18.1096 10.3614 18.1874 10.9153 18.0956 11.4541C18.0039 11.9928 17.747 12.4897 17.3606 12.8761L16.7301 13.5058C16.3993 13.8364 15.9508 14.0222 15.4831 14.0222C15.0154 14.0222 14.5668 13.8364 14.2361 13.5058L8.51704 19.2248C8.27132 19.4706 7.97957 19.6656 7.65848 19.7986C7.33738 19.9316 6.99322 20 6.64567 20H5.05827C4.7776 20 4.50842 19.8885 4.30996 19.69C4.1115 19.4916 4 19.2224 4 18.9417V17.3543C4.00007 17.0067 4.06865 16.6625 4.20181 16.3414C4.33497 16.0203 4.53011 15.7286 4.77606 15.483L10.4942 9.76391C10.1636 9.43315 9.97782 8.98461 9.97782 8.51691C9.97782 8.04922 10.1636 7.60068 10.4942 7.26992L11.1239 6.64025C11.5102 6.25371 12.0071 5.99671 12.5458 5.90477C13.0845 5.81282 13.6385 5.89048 14.1311 6.12699L15.4831 4.77506C15.7288 4.52934 16.0204 4.33442 16.3415 4.20143C16.6625 4.06845 17.0065 4 17.354 4C17.7015 4 18.0456 4.06845 18.3666 4.20143C18.6876 4.33442 18.9793 4.52934 19.2249 4.77506ZM11.7421 11.0109L6.02217 16.7308L5.94545 16.8181C5.82761 16.972 5.76376 17.1605 5.76378 17.3543V18.2362H6.64567L6.76208 18.2283C6.95402 18.2027 7.13222 18.1147 7.26916 17.9778L12.9891 12.2579L11.7421 11.0109ZM17.9771 6.02205C17.8117 5.85672 17.5874 5.76384 17.3536 5.76384C17.1197 5.76384 16.8955 5.85672 16.7301 6.02205L14.8658 7.88725C14.6987 8.05419 14.4722 8.14797 14.2361 8.14797C13.9999 8.14797 13.7735 8.05419 13.6064 7.88725C13.4427 7.72353 13.2206 7.63156 12.9891 7.63156C12.7576 7.63156 12.5355 7.72353 12.3718 7.88725L11.7421 8.51691L15.4831 12.2579L16.1128 11.6282C16.2765 11.4645 16.3684 11.2424 16.3684 11.0109C16.3684 10.7794 16.2765 10.5573 16.1128 10.3936C15.9458 10.2265 15.852 10.0001 15.852 9.76391C15.852 9.52775 15.9458 9.30127 16.1128 9.13424L17.9779 7.26992C18.0599 7.18802 18.125 7.09076 18.1694 6.9837C18.2138 6.87664 18.2366 6.76188 18.2366 6.64599C18.2366 6.53009 18.2138 6.41533 18.1694 6.30827C18.125 6.20121 18.0591 6.10395 17.9771 6.02205Z"
        fill="#8C94A5"
      />
    </svg>
  );
};

export const NoImage: FC<IIconProps> = ({
  width = 24,
  height = 24,
  sharedStyles,
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={sharedStyles}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.5 2.5605L21.4395 1.5L1.5 21.4395L2.5605 22.5L4.0605 21H19.5C19.8976 20.9994 20.2788 20.8412 20.56 20.56C20.8412 20.2788 20.9994 19.8976 21 19.5V4.0605L22.5 2.5605ZM19.5 19.5H5.5605L11.4052 13.6553L13.1895 15.4395C13.4708 15.7207 13.8523 15.8787 14.25 15.8787C14.6477 15.8787 15.0292 15.7207 15.3105 15.4395L16.5 14.25L19.5 17.2477V19.5ZM19.5 15.126L17.5605 13.1865C17.2792 12.9053 16.8977 12.7473 16.5 12.7473C16.1023 12.7473 15.7208 12.9053 15.4395 13.1865L14.25 14.376L12.4672 12.5933L19.5 5.5605V15.126ZM4.5 16.5V14.25L8.25 10.5023L9.27975 11.5327L10.3417 10.4708L9.3105 9.4395C9.02921 9.15829 8.64775 9.00032 8.25 9.00032C7.85225 9.00032 7.47079 9.15829 7.1895 9.4395L4.5 12.129V4.5H16.5V3H4.5C4.1023 3.0004 3.721 3.15856 3.43978 3.43978C3.15856 3.721 3.0004 4.1023 3 4.5V16.5H4.5Z"
        fill="#8C94A5"
      />
    </svg>
  );
};

export const SpaceIcon: FC<IIconProps> = ({
  width = 24,
  height = 24,
  sharedStyles,
}) => {
  return <div className={s.spaceIcon} style={{ width, height }}></div>;
};

export const RejectIcon: FC<IIconProps> = ({
  width = 24,
  height = 24,
  sharedStyles,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={sharedStyles}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 5C16.175 5 5 16.175 5 30C5 43.825 16.175 55 30 55C43.825 55 55 43.825 55 30C55 16.175 43.825 5 30 5ZM42.5 38.975L38.975 42.5L30 33.525L21.025 42.5L17.5 38.975L26.475 30L17.5 21.025L21.025 17.5L30 26.475L38.975 17.5L42.5 21.025L33.525 30L42.5 38.975Z"
        fill="#FF2D2D"
      />
    </svg>
  );
};

export const VkIcon: FC<IIconProps> = ({
  width = 24,
  height = 24,
  sharedStyles,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={sharedStyles}
    >
      <path
        d="M37.6825 5H22.345C8.33 5 5 8.3325 5 22.3175V37.6575C5 51.6675 8.3075 55 22.3175 55H37.6575C51.6675 55 55 51.6925 55 37.6825V22.345C55 8.33 51.6925 5 37.6825 5ZM45.365 40.675H41.7175C40.3375 40.675 39.9225 39.5575 37.4475 37.0825C35.2875 35 34.375 34.74 33.8275 34.74C33.0725 34.74 32.865 34.9475 32.865 35.99V39.27C32.865 40.1575 32.5775 40.6775 30.26 40.6775C28.0109 40.5264 25.8298 39.843 23.8965 38.6838C21.9632 37.5246 20.3329 35.9227 19.14 34.01C16.3079 30.485 14.3374 26.3478 13.385 21.9275C13.385 21.38 13.5925 20.885 14.635 20.885H18.2825C19.22 20.885 19.5575 21.3025 19.9225 22.265C21.6925 27.475 24.7125 32.005 25.9375 32.005C26.4075 32.005 26.6125 31.7975 26.6125 30.625V25.26C26.4575 22.8125 25.1575 22.605 25.1575 21.72C25.1742 21.4866 25.2812 21.2688 25.4557 21.1129C25.6303 20.9571 25.8587 20.8753 26.0925 20.885H31.8225C32.605 20.885 32.865 21.275 32.865 22.2125V29.4525C32.865 30.235 33.2025 30.495 33.4375 30.495C33.9075 30.495 34.27 30.235 35.13 29.375C36.9772 27.1224 38.4863 24.6127 39.61 21.925C39.7249 21.6022 39.9422 21.3258 40.2288 21.138C40.5155 20.9502 40.8557 20.8614 41.1975 20.885H44.845C45.9375 20.885 46.17 21.4325 45.9375 22.2125C44.6112 25.1836 42.9702 28.0039 41.0425 30.625C40.65 31.225 40.4925 31.5375 41.0425 32.24C41.405 32.7875 42.6825 33.855 43.5425 34.87C44.7923 36.1166 45.8301 37.5589 46.615 39.14C46.9275 40.155 46.405 40.675 45.365 40.675Z"
        fill="#8C94A5"
      />
    </svg>
  );
};

export const YouTubeIcon: FC<IIconProps> = ({
  width = 24,
  height = 24,
  sharedStyles,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={sharedStyles}
    >
      <path
        d="M25 37.5L37.975 30L25 22.5V37.5ZM53.9 17.925C54.225 19.1 54.45 20.675 54.6 22.675C54.775 24.675 54.85 26.4 54.85 27.9L55 30C55 35.475 54.6 39.5 53.9 42.075C53.275 44.325 51.825 45.775 49.575 46.4C48.4 46.725 46.25 46.95 42.95 47.1C39.7 47.275 36.725 47.35 33.975 47.35L30 47.5C19.525 47.5 13 47.1 10.425 46.4C8.175 45.775 6.725 44.325 6.1 42.075C5.775 40.9 5.55 39.325 5.4 37.325C5.225 35.325 5.15 33.6 5.15 32.1L5 30C5 24.525 5.4 20.5 6.1 17.925C6.725 15.675 8.175 14.225 10.425 13.6C11.6 13.275 13.75 13.05 17.05 12.9C20.3 12.725 23.275 12.65 26.025 12.65L30 12.5C40.475 12.5 47 12.9 49.575 13.6C51.825 14.225 53.275 15.675 53.9 17.925Z"
        fill="#8C94A5"
      />
    </svg>
  );
};

export const TelegramIcon: FC<IIconProps> = ({
  width = 24,
  height = 24,
  sharedStyles,
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={sharedStyles}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title />
      <g
        data-name="telegram social media network chat"
        id="telegram_social_media_network_chat"
      >
        <path d="M28.59,4.29a2.23,2.23,0,0,0-2.27-.36L3.41,13.1a1.83,1.83,0,0,0,0,3.38l1.48.61a1,1,0,0,0,1.31-.53,1,1,0,0,0-.54-1.31L4.56,14.8l22.51-9a.22.22,0,0,1,.23,0,.24.24,0,0,1,.08.23L23.27,25.21a.4.4,0,0,1-.26.3.39.39,0,0,1-.39-.06l-8-6.24,7.83-7.91a1,1,0,0,0-1.22-1.56L9.75,16.54a1,1,0,1,0,1,1.72l4.83-2.85L13.23,17.8a2,2,0,0,0,.2,3.08l8,6.15a2.4,2.4,0,0,0,1.47.5,2.47,2.47,0,0,0,.83-.15,2.37,2.37,0,0,0,1.52-1.75L29.33,6.47A2.23,2.23,0,0,0,28.59,4.29Z" />
      </g>
    </svg>
  );
};
